const MASK_VISIBLE_LENGTH = 8;
const MASK_PLACEHOLDER = 'XXXXXXXXXX';
const EXPIRATION_YEAR_DIGITS = 2;

/** MM/AA a partir de expiration_month y expiration_year (2 dígitos, o 4 si viniera completo). */
export function formatCardExpiration(month: unknown, year: unknown): string {
  const rawMonth = String(month ?? '').trim();
  const rawYear = String(year ?? '').trim();
  if (!rawMonth || !rawYear) {
    return '';
  }
  return `${rawMonth.padStart(2, '0')}/${rawYear.slice(-EXPIRATION_YEAR_DIGITS)}`;
}

/** Últimos 8 caracteres del número enmascarado (mismo criterio que el listado de tarjetas). */
export function maskCardNumber(maskCard: string | null | undefined): string {
  return maskCard != null ? maskCard.substr(maskCard.length - MASK_VISIBLE_LENGTH) : MASK_PLACEHOLDER;
}

/** Segunda línea de una dirección: "Ciudad, PAÍS CP", omitiendo partes vacías. */
export function formatAddressDetail(address: { city?: string | null; country?: string | null; zipCode?: string | null }): string {
  const clean = (value: string | null | undefined): string => (value ?? '').toString().trim();
  const countryZip = [clean(address.country), clean(address.zipCode)].filter(Boolean).join(' ');
  return [clean(address.city), countryZip].filter(Boolean).join(', ');
}
